'use es6';

import { List } from 'immutable';
import { createSelector } from 'reselect';
export const getProductsState = state => state.products;
export const getProducts = createSelector(getProductsState, productsState => productsState.get('data') || List());
export const getHubPricingData = createSelector(getProducts, products => products.filter(product => product.get('productType') === 'SOFTWARE' && product.get('productLine') && product.get('productLevel') && product.get('productLevel') !== 'DEPRECATED').reduce((pricingData, product) => {
  const productLine = product.get('productLine').toLowerCase();
  let productLevel = product.get('productLevel').toLowerCase();
  productLevel = productLevel === 'professional' ? 'pro' : productLevel;
  if (!product.get('productVersions').size) {
    return pricingData;
  }
  let currentVersion = product.get('productVersions').find(version => version.get('versionType') === 'CURRENT');
  if (!currentVersion) {
    currentVersion = product.get('productVersions').get(0);
  }
  const currentVersionPrices = currentVersion.get('pricingWrap').get('prices');
  pricingData[productLine] = Object.assign({}, pricingData[productLine] || {}, {
    [productLevel]: currentVersionPrices.reduce((currencyMap, price) => {
      currencyMap[price.get('currencyCode')] = price.get('value');
      return currencyMap;
    }, {})
  });
  return pricingData;
}, {}));